module.exports = __webpack_public_path__ + "img/how_it_work_th.5b0abca4.png";